<template>
  <form class="space-y-6 mx-auto px-4 lg:px-0">
    <div class="general-info">
      <!-- <h3 class="text-primary font-semibold mb-2">General information</h3> -->
      <div class="input-fields w-full lg:grid lg:grid-cols-2 lg:gap-x-4">
        <div class="input-field">
          <input-label name="first_name">First Name</input-label>
          <text-input
            class="bg-platinum-gray rounded-xl"
            v-model="form.first_name"
            name="first_name"
          />
          <input-error :field="v.first_name" />
        </div>
        <div class="input-field">
          <input-label name="last_name">Last Name</input-label>
          <text-input
            class="bg-platinum-gray rounded-xl"
            v-model="form.last_name"
            name="last_name"
          />
          <input-error :field="v.last_name" />
        </div>
        <div class="input-field">
          <input-label name="email">Email Address</input-label>
          <text-input
            class="bg-platinum-gray rounded-xl"
            v-model="form.email"
            name="email"
          />
          <input-error :field="v.email" />
        </div>
        <div class="input-field">
          <input-label name="emailConfirmation">Email Confirmation</input-label>
          <text-input
            class="bg-platinum-gray rounded-xl"
            v-model="form.emailConfirmation"
            name="emailConfirmation"
            type="email"
          />
          <input-error :field="v.emailConfirmation" />
        </div>
        <div class="input-field">
          <input-label name="password">Password</input-label>
          <text-input
            class="bg-platinum-gray rounded-xl"
            v-model="form.password"
            name="password"
            type="password"
          />
          <input-error :field="v.password" />
        </div>
        <div class="input-field">
          <input-label name="passwordConfirmation"
            >Password Confirmation</input-label
          >
          <text-input
            class="bg-platinum-gray rounded-xl"
            v-model="form.passwordConfirmation"
            name="passwordConfirmation"
            type="password"
          />
          <input-error :field="v.passwordConfirmation" />
        </div>
        <div class="input-field">
          <input-label name="eeni">NIB Number</input-label>
          <text-input
            class="bg-platinum-gray rounded-xl"
            v-model="form.eeni"
            name="eeni"
          />
          <input-error :field="v.eeni" />
        </div>
      </div>
      <!-- <div class="contact-info">
        <div class="header">
          <h3 class="font-semibold text-primary mb-2 inline">
            Contact information
          </h3>
          <a
            class="cursor-pointer text-green-500 hover:text-green-400 ml-2"
            @click="addContact"
          >
            <svg
              class="w-5 h-5 inline"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </a>
        </div>
        <div class="input-fields">
          <div
            v-for="(contact, i) in form.contacts"
            :key="i"
            class="contact md:grid md:grid-cols-2 md:gap-x-4 relative"
          >
            <a
              v-if="form.contacts.length > 1"
              class="
                remove-btn
                absolute
                top-0
                right-0
                text-red-500
                hover:text-red-400
                cursor-pointer
                z-10
              "
              @click="removeContact(i)"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </a>
            <div class="input-field">
              <input-label name="phone_type">Phone type</input-label>
              <select-input
                v-model="form.contacts[i].phone_type"
                name="phone_type"
              >
                <option v-for="(type, i) in phoneTypes" :key="i" :value="type">
                  {{ type }}
                </option>
              </select-input>
              <span
                v-if="
                  v.contacts.$each.$response.$errors[i].phone_type.length &&
                  v.contacts.$dirty
                "
                class="text-sm font-semibold text-red-500"
              >
                {{
                  v.contacts.$each.$response.$errors[i].phone_type[0].$message
                }}
              </span>
            </div>
            <div class="input-field">
              <input-label name="phone_number">Phone no.</input-label>
              <text-input
                v-model="form.contacts[i].phone_number"
                name="phone_number"
                type="text"
              />
              <span
                v-if="
                  v.contacts.$each.$response.$errors[i].phone_number.length &&
                  v.contacts.$dirty
                "
                class="text-sm font-semibold text-red-500"
              >
                {{
                  v.contacts.$each.$response.$errors[i].phone_number[0].$message
                }}
              </span>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="submit-btn justify-end flex">
      <nib-btn
        class="bg-primary hover:bg-primaryLighten w-full rounded-xl"
        dark
        @click="register"
        :loading="isLoading"
        >Register</nib-btn
      >
    </div>
    <div class="mt-4 flex justify-between items-center">
      <p class="text-sm lg:text-base">Already have an account?</p>
      <p>
        <router-link
          :to="{ name: 'login' }"
          class="
            font-semibold
            cursor-pointer
            text-primary text-sm
            lg:text-base
            hover:text-primaryLighten hover:underline
          "
          >Login here.
        </router-link>
      </p>
    </div>
  </form>

  <div class="bottom fixed bottom-10 right-10">
    <NibSpinner v-if="isLoading" />
  </div>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from "vue";
import {
  required,
  email,
  numeric,
  minLength,
  maxLength,
  helpers,
  sameAs,
} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import useUserData from "../../../composables/useUserData";

const { registerUser } = useUserData();
const phoneTypes = ["Home", "Work", "Mobile"];
const isLoading = ref(false);

const form = reactive({
  first_name: "",
  last_name: "",
  eeni: "",
  email: "",
  emailConfirmation: "",
  password: "",
  passwordConfirmation: "",
  // contacts: [{ phone_type: "", phone_number: "" }],
});

const rules = computed(() => ({
  first_name: { required },
  last_name: { required },
  eeni: {
    required,
    numeric,
    minLength: helpers.withMessage(
      () => `N.I numbers are eight digits in length.`,
      minLength(8)
    ),
    maxLength: helpers.withMessage(
      () => `N.I numbers are eight digits in length.`,
      maxLength(8)
    ),
  },
  email: { required, email },
  emailConfirmation: { required, email, sameAs: sameAs(form.email) },
  password: {
    required,
  },
  passwordConfirmation: { required, sameAs: sameAs(form.password) },
  // contacts: {
  //   $each: helpers.forEach({
  //     phone_type: { required },
  //     phone_number: { required },
  //   }),
  //   minLength: helpers.withMessage(
  //     () => `You need to provide at least one contact number.`,
  //     minLength(1)
  //   ),
  // },
}));

// const addContact = () => {
//   if (form.contacts.length == 3) return false;
//   form.contacts.push({ phone_type: "", phone_number: "" });
// };

// const removeContact = (index: number) => {
//   if (form.contacts.length == 1) return false;
//   form.contacts.splice(index, 1);
// };

const v = useVuelidate(rules, form);

const register = async () => {
  if (!isLoading.value) {
    v.value.$touch();

    if (v.value.$invalid) return false;

    isLoading.value = true;

    await registerUser(form);

    isLoading.value = false;
  }
};
</script>

<style lang="postcss" scoped>
form {
  max-width: 350px;
}

@screen md {
  form {
    max-width: 600px;
  }
}
</style>
